import { App } from 'antd';

export const GlobalAntdMessage = () => {
  const staticFunction = App.useApp();
  if (typeof window === 'undefined') return null;
  (window as any).__antd_message = staticFunction.message;
  (window as any).__antd_modal = staticFunction.modal;
  (window as any).__antd_notification = staticFunction.notification;
  return null;
};
